import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useModalData } from 'hooks/index'
// components
import { DrawerModal } from 'components/UI'
import { Header } from 'components/Modals/PlanItems/styles'
import { FloatingBottomPaper } from 'components/FormElements/FloatingActions/views'
import ObjectiveDetails from 'components/Modals/LinkingSourceModal/components/ObjectiveDetails'
import ActionDetails from 'components/Modals/LinkingSourceModal/components/ActionDetails'
import KPIDetails from 'components/Modals/LinkingSourceModal/components/KPIDetails'
// constants
import { Modals, ENTITIES } from 'constants/index'
// context
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// utils
import get from 'lodash/get'

const Wrapper = styled('div')`
  height: calc(100% - 114px);

  ${FloatingBottomPaper} {
    width: 600px;
    left: 0;
  }
`

const PAPER_PROPS = {
  style: {
    top: 64,
    height: 'calc(100% - 64px)',
    overflow: 'hidden',
    zIndex: 1300,
    borderRight: '2px solid'
  }
}

const LinkingSourceModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, title, width }
  } = useModalData({ modalType: Modals.LINKING_SOURCE_DETAILS_MODAL })

  const { linkingSource } = React.useContext(LinkingModeContext)

  return (
    <DrawerModal
      width={width}
      isOpen={isOpen}
      anchor={'left'}
      hideModal={hideModal}
      variant={'persistent'}
      PaperProps={PAPER_PROPS}>
      <Header>
        <span>{title}</span>
      </Header>

      <Wrapper>
        {get(linkingSource, 'entityType') === ENTITIES.PLAN_OBJECTIVE && <ObjectiveDetails entity={linkingSource} />}
        {get(linkingSource, 'entityType') === ENTITIES.PLAN_ACTION && <ActionDetails entity={linkingSource} />}
        {get(linkingSource, 'entityType') === ENTITIES.PLAN_KPI && <KPIDetails entity={linkingSource} />}
      </Wrapper>
    </DrawerModal>
  )
}

export default LinkingSourceModal
